import { memo } from 'react';

import deepLink from '../DeepLink/hoc';
import { CustomizeButton } from './PDPDetailsComponents';

import { isIOSDevice } from '../../utils/browser';
import { buildCreateCardDeepLinkPath } from '../../utils/urls';

// @ts-expect-error
const CustomizeAppDeepLink = deepLink(CustomizeButton, {
  campaign: 'pdp_customize',
  feature: 'pdp',
});

export const CustomizeOptions = ({
  compositionId,
  customizeTrackingProps = {},
  customizeURL,
  id,
  productType,
}: {
  id: string | undefined;
  customizeURL: string;
  customizeTrackingProps: any;
  productType: string;
  compositionId: string | undefined;
}) => {
  const isIOS = isIOSDevice();

  const deepLinkData = {
    // Newer versions (~7.19.1 and greater) use $deeplink_path
    // See PagesRN/App/NativeModules/Branch for typings
    $deeplink_path: buildCreateCardDeepLinkPath(id || '', compositionId || ''),
    // Older versions of the iOS app use cardPackage
    cardPackage: id,
  };

  return (
    <div className="flex text-center items-baseline">
      <CustomizeButton className="flex-grow" href={customizeURL} tracking={customizeTrackingProps}>
        {productType !== 'flyer' || customizeTrackingProps?.ispremium
          ? 'Customize'
          : 'Customize for free'}
      </CustomizeButton>
      {productType !== 'flyer' && isIOS && (
        <CustomizeAppDeepLink
          authRequired={false}
          className="flex-grow"
          customizeInApp
          data={deepLinkData}
          linkId={id}
        >
          Customize in App
        </CustomizeAppDeepLink>
      )}
    </div>
  );
};

const MobileCardCustomizeActions = ({
  compositionId,
  customizeTrackingProps,
  customizeURL,
  id,
  productType,
}: {
  className?: string;
  id?: string;
  compositionId: string;
  customizeURL: string;
  customizeTrackingProps: any;
  productType: string;
}) => {
  return (
    <div className="flex flex-col">
      <CustomizeOptions
        compositionId={compositionId}
        customizeTrackingProps={customizeTrackingProps}
        customizeURL={customizeURL}
        id={id}
        productType={productType}
      />
    </div>
  );
};

export default memo(MobileCardCustomizeActions);
